import React from "react";
import { Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import myshop from "../../assets/image/hvacac.jpg";
import deep1 from "../../assets/image/AC5.jpg";
import deep2 from "../../assets/image/Hero2.jpg";

import "../../index.css";
import OtherPageTopBanner from "../../Herosection/Components/OtherPageTopBanner";

const services = [
  {
    id: 1,
    title: "HVAC Design & Consultancy Services",
    description: `
      HVAC Design & Consultancy involves scientific planning, calculation, and layout design of air conditioning systems to ensure optimum comfort, energy efficiency, and system performance. We offer expert HVAC consultation based on accurate Heat Load Calculations, tailored layout planning, and system selection suited for any space.

      Our Core Offerings:
      • Heat Load Calculation: Accurate sizing of AC units based on room structure, insulation, sunlight, and usage.
      • Complete HVAC Layout Design: Indoor/outdoor unit placement, duct design, and uniform cooling strategy.
      • Equipment Recommendation: Choosing the right AC type (Split, Cassette, VRV/VRF) as per usage and budget.
      • Consultation & Site Visit: Professional on-site assessments and HVAC planning by expert engineers.

      Why Choose Us:
      • Expertise & Accuracy – Led by HVAC expert Makrand K. Gadre
      • Energy Efficiency Focus – Save cost with smart design
      • Customized Solutions – Tailored for your exact needs
      • End-to-End Support – From design to execution

      We serve Offices, Residential Villas, Industrial Plants, Hotels, Educational Institutions, and Retail Stores.

       Our Core Offerings
       Heat Load Calculation 
       Scientific calculation based on room dimensions, insulation, glass area, sunlight exposure, number of occupants, and equipment heat.

       Ensures correct tonnage and system sizing.

       Prevents over or under-cooling and saves energy.

       Complete HVAC Layout Design

       Detailed schematic design of indoor and outdoor unit placement.

       Ductwork design for centralized AC systems.

       Ensures uniform cooling, easy maintenance access, and aesthetic integration.

       Equipment Recommendation & Specification

       Suggesting the most suitable type of AC (Split, Cassette, Ductable, VRV/VRF, etc.).

       Based on client’s budget, usage pattern, and energy goals.

       Consultation & Site Visit

       On-site assessment by our experienced engineers.

       Consultation on existing HVAC challenges or new project requirements.

      🔹 Why Choose Us?

      ✅ Expertise & Accuracy – Led by industry expert Makrand K. Gadre, our designs are based on engineering precision.

      ✅ Energy Efficiency Focus – We aim for long-term cost savings through proper system sizing and placement.

      ✅ Customized Solutions – Every design is tailored to the specific architectural and functional needs of your premises.

      ✅ End-to-End Support – From design to execution, we work closely with your project team or provide complete solution through our supply & installation service.

      🔹 Where Our Services Fit 

      🏢 Corporate Offices

      🏠 High-end Residential Villas

      🏭 Industrial Plants

      🏨 Hotels & Hospitality

      🏫 Educational Institutions

      🏬 Shopping Malls & Retail

      🔹 Let’s Plan Your HVAC System Smartly!
          Whether you’re planning a new project or upgrading your existing setup, our HVAC Design & Consultancy will ensure comfort, performance, and savings.

      📞 Contact us today for a free consultation or to schedule a site visit.

          Phone: +91 9893118833
          Email: Innovations.Enterprises@rediffmail.com
    `,
    image: myshop,
  },
  {
    id: 2,
    title: "AC Supply & Installation Services",
    description: `
      We provide complete AC Supply & Installation services tailored to meet the cooling requirements of residential, commercial, and industrial spaces. Our team ensures the perfect selection, reliable supply, and professional installation of air conditioners to deliver maximum comfort and energy efficiency.

      Our Services Include:

      Air Conditioner Supply

      Wide range of top brands (Daikin, Mitsubishi, LG, Voltas, etc.)

      Options available for Split AC, Window AC, Cassette AC, Ductable AC, and VRV/VRF systems

      Guidance in selecting the right capacity and type based on your space and usage.

      Professional Installation

      Expert site inspection before installation

      Proper mounting, placement, and leveling of indoor and outdoor units

      Accurate refrigerant piping and electrical connections

      Testing of complete system for cooling performance

      Customized Solutions

      Residential apartments and villas

      Offices, Shops, Showrooms, and Restaurants

      Industrial Units, Hospitals, and Educational Institutions

      After-Sales Support

      Post-installation service checks

      AMC (Annual Maintenance Contracts) available

      Quick assistance in case of faults or issues

      Why Choose Us?

      ✅ Experienced Team — Skilled technicians with years of installation expertise
      ✅ Genuine Products — We only supply 100% original products with warranty
      ✅ Competitive Pricing — Best rates without compromising quality
      ✅ On-Time Completion — Hassle-free and timely service delivery
      ✅ Customer Satisfaction — Dedicated support before and after installation

      Brands We Deal In: 
      
      Daikin
      Mitsubishi
      Blue Star
      LG
      Voltas
      Hitachi
      Carrier
      Panasonic

      📞 Get In Touch
      Looking to install a new AC system?
      Contact us today for a free site visit and quotation!

      Phone: +91 9893118833
      Email: Innovations.Enterprises@rediffmail.com
      
    `,
    image: deep1,
  },
  {
    id: 3,
    title: "Maintenance & After-Sales Support",
    description: `
      We believe that delivering a quality air conditioning solution doesn’t end at installation — it continues with our dedicated maintenance and after-sales support. Our aim is to ensure your AC systems run efficiently, reliably, and with maximum lifespan.
      
      Our Services Include:

      Preventive Maintenance:-

        Scheduled servicing to clean filters, coils, and condenser units
        Refrigerant level check and top-up if required
        Inspection of electrical components and cooling performance
        Early detection and fixing of potential issues to avoid breakdowns

      On-Demand Repairs:-

        Fast response to breakdowns or performance issues
        Diagnosis and repair of faults like gas leaks, compressor failure, wiring faults, etc.
        Use of genuine spare parts for reliable repairs

      Annual Maintenance Contracts (AMC):-

        Hassle-free maintenance with pre-scheduled visits
        Priority service and discounted repair charges for AMC customers
        Different AMC packages based on customer needs (Basic, Comprehensive, Premium)

      System Upgrades & Replacement:-

         Advice and support if your AC system becomes outdated or inefficient
         Assistance in replacing parts or upgrading to newer energy-efficient models

      Customer Support:-

         Friendly, responsive customer care
         Helpdesk support via phone, email, and WhatsApp
         Transparent communication on service charges and timelines

      Why Our Maintenance Services?

      ✅ Extend the Life of Your AC — Regular maintenance keeps your system healthy longer
      ✅ Save on Energy Costs — Well-maintained AC units consume less power
      ✅ Minimize Downtime — Prevent unexpected breakdowns during peak seasons
      ✅ Peace of Mind — Priority support for emergency situations
      ✅ Professional Technicians — Trained experts using standard procedures and equipment

      📞 Need Help?
      Whether you need a one-time AC service or want to sign up for an AMC,
      we are just a call away!

      Phone: +91 9893118833
      Email: Innovations.Enterprises@rediffmail.com

      
    `,
    image: deep2,
  }
];

function ServiceDetails() {
  const { id } = useParams();
  const service = services.find((item) => item.id === parseInt(id));

  if (!service) {
    return <h2 className="text-danger text-center">Service Not Found!</h2>;
  }

  return (
    <>
      <OtherPageTopBanner title={service.title} />
      <div id="services-section">
        <div className="mt-5 container-fluid px-md-5">
          <div id="services-header">
            <h2 className="text-primary text-start mb-4">{service.title}</h2>
          </div>
          <Row className="justify-content-center">
            <div key={service.id} className="mb-4">
              <div className="service-card">
                <div className="image-container">
                <img
  src={service.image}
  alt={service.title}
  className="card-img"
  style={{ width: "100%", height: "500px", objectFit: "cover" }}
/>

                </div>
                <div className="card-content">
                  <h3 className="text-primary">{service.title}</h3>
                  <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
                    {service.description}
                  </pre>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
}

export default ServiceDetails;
